// 支出割合（%）に応じた表示レベル（背景色）。
// 収支登録画面の「今月の支出割合」と月次集計画面の「目標限度額」で同じルールを使う。
export type ExpenseRatioLevel = "none" | "safe" | "caution" | "warning" | "danger";

export const getExpenseRatioLevel = (ratio: number | null): ExpenseRatioLevel => {
  if (ratio === null) return "none";
  if (ratio < 50) return "safe";
  if (ratio < 75) return "caution";
  if (ratio < 90) return "warning";
  return "danger";
};
